import { gql } from 'graphql-request'

export const GET_PROMOTION_CODE_DUP_FORM = gql`
  query PromotionCode($promotionId: Float!) {
    promotion(id: $promotionId) {
      promotionCode {
        type
        buyCoinConditionValue
        buyCoinCondition
        paymentChannels
        benefitValue
        coin {
          id
          name
        }
        channels {
          name
          totalCount
        }
      }
      name
      description
      userTerm
      startPublishedAt
      endPublishedAt
      publishedType
      userType
      isFirstTopUp
      usageLimitPerUser
      isUsageLimitPerUser
      usageLimit
      isUsageLimit
      usageDay
      status
      users {
        id
      }
      usersFileName
      usersFilePath
      type
    }
  }
`
